export default {
  primary: 'inverse',
  secondary: 'secondary',
  naked: 'link-01',
  'naked-inverse': 'link-01-inverse',
  outline: 'secondary',
  'outline-white': 'inverse',
  link: 'link-01',
  blue: 'inverse',
}
